import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { confirmIncomingCar, getIncomingCars } from '../actions';
import { selectIncoming } from '../selectors';
import { selectWork, selectWorks } from '../../Api/selectors';
import { GET_INCOMING_CARS, ORB_DOMAIN } from '../constants';
import { Pagination } from '../../../components/Pagination';
import { HBox, VBox } from '../../../components/Box';
import { Checkbox } from '../../../components/Checkbox';
import { Button } from '../../../components/Buttons';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';

const Container = styled.div``;

const WarningWrapper = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
`;

const STATE = {
  currentPage: 0,
  selectedCar: {},
  inputs: [],
};

/* eslint-disable react/prefer-stateless-function */
class ORBIncomingComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchIncomingCars();
  }

  handlePageChange = newPage => {
    this.setState(
      {
        currentPage: newPage,
        selectedCar: {},
        inputs: [],
      },
      this.props.fetchIncomingCars(null, newPage),
    );
  };

  selectCar = idx => {
    let updated = { ...this.state.selectedCar };

    if (this.state.selectedCar.hasOwnProperty(idx) && this.state.selectedCar[idx] === true) {
      updated[idx] = false;
      this.setState({ selectedCar: { ...updated } });
    } else {
      updated[idx] = true;
      this.setState({ selectedCar: { ...updated } });
    }
  };

  confirmVehicle = () => {
    const requestData = [];
    for (const car in this.state.selectedCar) {
      const source = this.props.incoming.editable.filter(c => c.id == car)[0];
      const inputed = this.state.inputs[car];

      const data = {
        reg_plate: source?.regPlate ?? '',
        mileage: inputed?.mileage ?? source?.mileage ?? 0,
        mileage_unit: 'K',
        // status_code_mileage: inputed?.noCounter ? 'X' : `${source.noCounter}`,
        mileage_report: inputed?.requestReport ?? source?.requestReport,
        reg_plate_card: inputed?.requestCard ?? source.requestCard,
        technical_claim_handling: inputed?.useIllogical ? 'A' : 'B',
      };

      requestData.push(data);
    }

    this.props.confirm(requestData);

    this.setState({ selectedCar: {}, inputs: [] });
  };

  onMileageChange = (evt, idx) => {
    let updated = [...this.state.inputs];
    if (!updated[idx]) updated[idx] = {};
    updated[idx].mileage = evt.target.value;
    this.setState({ inputs: [...updated] });
  };

  onNoCounter = idx => {
    let updated = [...this.state.inputs];
    if (!updated[idx]) updated[idx] = {};
    updated[idx].noCounter = !updated[idx].noCounter;
    this.setState({ inputs: [...updated] });
  };

  onIllogical = idx => {
    let updated = [...this.state.inputs];
    if (!updated[idx]) updated[idx] = {};
    updated[idx].useIllogical = !updated[idx].useIllogical;
    this.setState({ inputs: [...updated] });
  };

  onRequestCard = idx => {
    let updated = [...this.state.inputs];
    if (!updated[idx]) updated[idx] = {};
    updated[idx].requestCard = !updated[idx].requestCard;
    this.setState({ inputs: [...updated] });
  };

  onRequestReport = idx => {
    let updated = [...this.state.inputs];
    if (!updated[idx]) updated[idx] = {};
    updated[idx].requestReport = !updated[idx].requestReport;
    this.setState({ inputs: [...updated] });
  };

  renderCard = (item, idx) => {
    return (
      <VBox vCenter left key={`incoming${item?.id}`} style={{ margin: '10px 0', width: '100%', backgroundColor: 'white' }}>
        <HBox vCenter style={{ padding: 10, borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox checked={this.state.selectedCar[idx] === true} onChange={() => this.selectCar(idx)} />
            <span style={{ textAlign: 'left' }}>
              <strong>{item?.regPlate ?? 'Unknown Licenseplate'}</strong>
              {item?.merk ? ` | ${item?.merk} ${item?.model}` : ' | N/A'}
            </span>
          </div>
        </HBox>
        <HBox flip={window.innerWidth <= 768}>
          <VBox style={{ padding: '12px', gap: 10 }}>
            <HBox left style={{ gap: 5 }}>
              <strong>Status: </strong> {item?.status}
            </HBox>
            <HBox left style={{ gap: 5 }}>
              <strong>Updated on: </strong> {item?.updated}
            </HBox>
            <HBox left style={{ gap: 5 }}>
              <strong>RDW copper: </strong> {item?.rdw}
            </HBox>
            <HBox left style={{ gap: 5 }}>
              <strong>Company: </strong> {item?.company}
            </HBox>
          </VBox>
          <VBox style={{ padding: '12px' }}>
            <strong>Counter reading: </strong>

            <FormField>
              <Input
                key={`${idx}-mileage`}
                // value={item.mileage ?? ''}
                value={this.state.inputs[idx]?.mileage ?? ''}
                onChange={e => this.onMileageChange(e, idx)}
              />
            </FormField>
            <HBox left style={{ gap: 5 }}>
              <strong>{this.lbl('vehicle.property.mileage')}: </strong> {item?.mileage}
            </HBox>
            <Checkbox checked={this.state.inputs[idx]?.noCounter ?? false} onChange={() => this.onNoCounter(idx)}>
              Geen tellerstand
            </Checkbox>
            <Checkbox checked={this.state.inputs[idx]?.useIllogical ?? false} onChange={() => this.onIllogical(idx)}>
              Als deze WEL is aangevinkt gaat hij door bij een onlogische tellerstand of een wok-melding
            </Checkbox>
            <Checkbox checked={this.state.inputs[idx]?.requestCard ?? false} onChange={() => this.onRequestCard(idx)}>
              Opvragen kentekenkaart
            </Checkbox>

            <Checkbox checked={this.state.inputs[idx]?.requestReport ?? false} onChange={() => this.onRequestReport(idx)}>
              Tellerrapport opvragen
            </Checkbox>
          </VBox>
        </HBox>
      </VBox>
    );
  };

  render() {
    if (this.props.loading) return <Loader small />;
    const { editable: items = [], paginator } = this.props?.incoming ?? {};
    if (!this.props.loading && !!items && !items?.length)
      return <WarningWrapper>{this.lbl('incoming.notfound')}</WarningWrapper>;

    return (
      <Container>
        <Button inline small onClick={this.confirmVehicle}>
          <strong>Accept selected transfers</strong>
        </Button>
        {items && Array.isArray(items) && items?.map((item, idx) => this.renderCard(item, idx))}
        {!!items?.length && paginator?.itemsCount > paginator?.limit && (
          <Pagination paginator={paginator} selectPage={this.handlePageChange} />
        )}
      </Container>
    );
  }
}

ORBIncomingComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    incoming: selectIncoming(),
    loading: selectWorks([ORB_DOMAIN, GET_INCOMING_CARS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchIncomingCars(info, offset, limit) {
      dispatch(getIncomingCars(info, offset, limit));
    },
    confirm: carInfo => {
      dispatch(confirmIncomingCar(carInfo));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ORBIncoming = compose(withRouter, withConnect)(ORBIncomingComp);
